export const roleLabels = {
    admin: 'Administrador',
    employee: 'Empleado',
};

export const statusLabels = {
    registered: 'Registrado',
    pending_payment: 'Pendiente de pago',
    pending_shipping: 'Pendiente de envio',
    shipped: 'Enviado',
    delivered: 'Entregado',
    cancelled: 'Cancelado',
};

export const shippingProviderLabels = {
    mensajero: 'Mensajero',
    forza: 'Forza',
    caex: 'CAEX',
};

export const shippingModeLabels = {
    standard: 'Estandar',
    cod: 'Pago contra entrega',
    collect: 'Collect',
};

export const codChargeTypeLabels = {
    pending_balance: 'Saldo pendiente',
    shipping_only: 'Solo envio',
    order_total: 'Total del pedido',
};

export const jewelryStatusLabels = {
    active: 'Activo',
    inactive: 'Inactivo',
};

export const labelFor = (labels, value) => labels[value] || value || '';
